<template>
  <div> 
    <ControlOption
      :campos="campos"
      :camposIndex="camposIndex">
      <!-- <v-container fluid> -->
        <!-- <row justify="center" align="center" subheading> -->
        <span>Pregunta: {{campos.pregunta + (campos.obligatorio== 1 ? '  **' : '')}}</span>
        <div subheading class="my-2" style="margin-left: 45% !important;" > 
          <v-icon
            x-large
            color="titlesdark darken-2">
            fas fa-camera
          </v-icon>
        </div>   
        <!-- </row> -->
      <!-- </v-container> -->
    </ControlOption>


  </div>
</template>

<script>
import ControlOption from "@/components/dragdrop/Campos/ControlOption.vue";

export default {
  name:"Foto",
  props: {
    campos: {
      type: Object,
      required: true
    },
    camposIndex: {
      type: Number,
      required: true
    },  
  },
  components: {
    ControlOption,
  },
  data() {
    return {
    }
  },
    
}
</script>

<style lang="scss" scoped>

</style>
